export const FontFamily = {
    Nunito:"Nunito",
    Lato:"Lato",
    Inter:"Inter",
    Ubuntu:"Ubuntu",
    Poppins:"Poppins"
}